import { defineStore } from 'pinia'

const STORAGE_KEY = 'shownTips'

function loadTips() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}
  } catch {
    return {}
  }
}

function saveTips(tips) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(tips))
}

export const useTipStore = defineStore({
  id: 'tip-store',
  state: () => ({
    shownTips: loadTips(),
  }),
  actions: {
    markTipShown(tipKey) {
      this.shownTips[tipKey] = true
      saveTips(this.shownTips)
    },
    resetTip(tipKey) {
      this.shownTips[tipKey] = false
      saveTips(this.shownTips)
    },
    resetAllTips() {
      this.shownTips = {}
      saveTips(this.shownTips)
    },
		checkTip(tipKey, autoHide = false) {
			const shown = !!this.shownTips[tipKey]
			console.log('checkTip', tipKey, shown)
			if (autoHide && !shown) {
				this.markTipShown(tipKey)
			}
			return shown
		}
  },
  getters: {
    isTipShown: (state) => (tipKey) => !!state.shownTips[tipKey],
  }
})
